export const LOAD_DISCOUNT = '[Discounts] LOAD_DISCOUNT';
export const LOAD_DISCOUNT_SUCCESS = '[Discounts] LOAD_DISCOUNT_SUCCESS';
export const LOAD_DISCOUNT_ERROR = '[Discounts] LOAD_DISCOUNT_ERROR';

export const loadDiscountsAction = () => ({ type: LOAD_DISCOUNT });
